import styled from 'styled-components'

// Design specifies White/Shade 50 for the input placeholder, which has no
// semantic theme token yet. Using the hex value until one is added.
const PLACEHOLDER_COLOR = '#808080'

// Visual resets use !important to guard against legacy Bootstrap/normalize
// global styles on Angular pages, where load order can cause element-level
// rules to override styled-component classes.
export const GlobalSearchInputFieldStyled = styled.input.attrs({
  type: 'text',
})`
  flex: 1;
  min-width: 0;
  height: 100%;
  width: 100%;

  border: none !important;
  border-radius: 0 !important;
  outline: none !important;
  box-shadow: none !important;
  padding: 0 !important;
  background: transparent !important;
  -webkit-appearance: none !important;

  font-family: inherit;
  /* stylelint-disable-next-line declaration-property-unit-disallowed-list --
   * Use px — Angular pages set html { font-size: 12px }, making rem unreliable. */
  font-size: 16px !important;
  font-weight: ${(props) => props.theme.fontWeights.normal};
  line-height: 1;
  color: ${(props) => props.theme.colors.text.primary};

  &::placeholder {
    opacity: 1;
    color: ${PLACEHOLDER_COLOR};
  }
`
